/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAdvTip.vue?vue&type=template&id=6097f579&scoped=true"
import script from "./popAdvTip.vue?vue&type=script&lang=js"
export * from "./popAdvTip.vue?vue&type=script&lang=js"
import style0 from "./popAdvTip.vue?vue&type=style&index=0&id=6097f579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097f579",
  null
  
)

export default component.exports